import { render, staticRenderFns } from "./currencyEditDialog.vue?vue&type=template&id=0854bf3b&"
import script from "./currencyEditDialog.vue?vue&type=script&lang=js&"
export * from "./currencyEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports